import React, { useEffect, useState } from "react";
import { Rept, sto } from "../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { mt } from "../../../St/comps/cStyle";
import { reFormatDate } from "../../../utils/utils";
import { insh } from "../../../Context/InshSt";
import { ButtonBase, colors, Container, makeStyles, Table, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRptCa, useRptMain } from '../../../St/Reviews/UseStyle';



function BodyCashair(props) {
    const { data, found, inv, sta ,onUnmountComplete} = props;

    const { t } = useTranslation(["forms", "translation"]);
    const cls = useRptAF();
    const clas = useRptCa();
    // const [data, setData] = useState(Rept.data);

    const cellS = {

        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.8rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.7rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };
    const clasm = useRptMain();
    //  const clasH = useInvHeadrCa();

    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };

    const cellSName = {

        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.8rem",
        width: "600px",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
    };
    var columns = [
        { title: "اسم الصنف", field: "symbol", headerStyle: styleE, cellStyle: cellSName, },
        { title: "الوحده", field: "unit_name", headerStyle: styleE, cellStyle: cellS, },
        { title: "الكمية", field: "val1", headerStyle: styleE, cellStyle: cellS, },
        { title: "السعر", field: "new_exchange_price", headerStyle: styleE, cellStyle: cellS, },
        { title: "الاجمالي", field: "tot_net_curr", headerStyle: styleE, cellStyle: cellS },
    ];

    var columns2 = [
        { title: "البيان", field: "symbol", headerStyle: styleE, cellStyle: cellSName, },
        { title: "السعر", field: "new_exchange_price", headerStyle: styleE, cellStyle: cellS, },
        { title: "الكمية", field: "val1", headerStyle: styleE, cellStyle: cellS, },
        { title: "الاجمالي", field: "tot_net_curr", headerStyle: styleE, cellStyle: cellS },
    ];
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const newData = data.map((row, i) => {
        return {
            ...row,
            tot_net_curr: parseFloat(row.tot_net_curr).toFixed(2),
            new_exchange_price: parseFloat(row.new_exchange_price).toFixed(2),

        };
    });
    useEffect(() => {
        setTimeout(async () => {
          onUnmountComplete();
        }, 0);
      }, []);
    
    return (
        <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
            <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
                <Grid
                    item
                    xs={12}
                >
                    <MaterialTable
                        style={{ boxShadow: "none" }}
                        // style={{direction:'ltr'}}
                        options={{
                            showTitle: false,
                            toolbar: false,
                            sorting: false,
                            selection: false,
                            // ToolBar Search
                            searchFieldAlignment: "left",
                            searchFieldVariant: "outlined",
                            // ToolBar header
                            showSelectAllCheckbox: false,
                            showTextRowsSelected: false,
                            pageSize: 5,


                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            paging: false,
                            headerStyle: stElemnt.EvDay.header,

                            cellStyle: {
                                ...stElemnt.AF.cell,
                                padding: "0px 1px",
                                // fontSize: 8,
                            },

                        }}
                        localization={{
                            body: {
                                emptyDataSourceMessage: (
                                    <h5 style={{ color: "GrayText" }}>
                                        لا توجد ارصدة بعد في هذا الحساب
                                    </h5>
                                ),
                            },
                        }}
                        columns={ premiApp?.cashirTemplate == 5 ? columns2:columns}
                        data={newData}
                    />

                </Grid>
            </Grid>

         
        </Grid>
    );
}

export default BodyCashair;
